import { createIcon } from '../createIcon';

export const CircleInfoIconConfig = {
  name: 'CircleInfoIcon',
  height: 512,
  width: 512,
  svgPath: 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z',
  yOffset: 0,
  xOffset: 0
};

export const CircleInfoIcon = createIcon(CircleInfoIconConfig);

export default CircleInfoIcon;